import { Layout } from "./Layout";
import { staticContent } from "./staticContent";

export const Postcampaign = () => {
  return (
    <Layout
      {...staticContent.globalContent}
      {...staticContent.postcampaign}
      postCampaign
    />
  );
};
